/* eslint-disable radix */
import 'antd/dist/antd.css';

import {
  Button,
  Dialog,
  Form,
  Input,
  Message,
  NumberPicker,
  Radio,
  Table,
  TimePicker,
} from '@alifd/next';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const RadioGroup = Radio.Group;
const CardManagementList = () => {
  // card Information
  const [cardArr, setCardArr] = useState([]);
  const [cardNumber, setCardNumber] = useState('');
  const [cardNumbering, setCardNumbering] = useState('');
  const [cardStatus, setCardStatus] = useState('未使用');
  const [editCardIndex, setEditCardIndex] = useState('');
  // card Dialog
  const [scanCardDialog, setScanCardDialog] = useState(false);
  const [cardInformationDialog, setCardInformationDialog] = useState(false);
  const [editCardInformationDialog, setEditCardInformationDialog] =
    useState(false);
  const [addTimeDialog, setAddTimeDialog] = useState(false);
  const [count, setCount] = useState(0);
  const [minute, setMinute] = useState(0);
  // username
  const [name, setName] = useState('');

  // cardManagement
  const cardManagement = client.service('cardManagement');
  // visitorAppointmentRegistration
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );

  async function funFindCard(para) {
    const result = await cardManagement.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funCreateCard(obj) {
    return await cardManagement.create(obj);
  }
  async function funUpdateCard(id, obj) {
    return await cardManagement.patch(id, obj);
  }

  // 20220311 修改加時錯誤
  async function funUpdateCardTime(id, obj) {
    const newObj = obj;
    // 20220309 加時同時修改visitorAppointmentRegistration資料表CardEndTime
    const result = await visitorAppointmentRegistration.find({
      query: {
        householdNumber: obj.householdNumber,
        cardNumber: obj.cardNumber,
        takeCardStatus: '已領卡',
      },
    });
    await visitorAppointmentRegistration.patch(result.data[0]._id, {
      cardEndTime: obj.allowTime,
    });
    return await cardManagement.patch(id, newObj);
  }
  async function funRemoveCard(id) {
    return await cardManagement.remove(id);
  }

  function serverCardDataUpdate() {
    funFindCard({}).then((result) => {
      console.log(result, '====serverCardResult');
      setCardArr(result);
    });
    console.log(cardNumber, '====cardNumber');
    // funFindVisitor({})
  }
  useEffect(() => {
    serverCardDataUpdate();
    client.reAuthenticate().then((data) => {
      setName(data.user.name);
    });
  }, []);

  // function cardNumVal(data){
  //   let card = parseInt(data)
  //   let newCard = (card >> 16) * 100000 + (card - ((card >> 16) << 16))
  //   let newCardNum = (Array(10).join("0") + newCard).slice(-10)
  //   console.log("==org:", data, "new:", newCardNum)
  //   setCardNumber(newCardNum);
  // }

  return (
    <>
      <Button
        className={styles.btnAdd}
        onClick={() => {
          setScanCardDialog(true);
        }}
      >
        新增
      </Button>

      <Dialog
        hasMask
        className={styles.scanCardDialog}
        visible={scanCardDialog}
        footer={false}
        onClose={() => {
          setScanCardDialog(false);
        }}
      >
        <Form>
          <BarcodeReader
            onScan={(data) => {
              const regex = /^[\d|a-zA-Z]+$/;
              try {
                const foundData = cardArr.find(
                  (element) => element.cardNumber === data
                );

                if (foundData === undefined) {
                  if (regex.test(data)) {
                    setCardNumber(data);
                    Message.success('掃描成功');
                    setCardInformationDialog(true);
                    setScanCardDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文(請切換英文輸入)');
                    setScanCardDialog(true);
                  }
                } else {
                  Message.error('已有此卡號，請換另一張卡片');
                }
              } catch (error) {
                console.log('Error', error);
              }
            }}
            onError={(err) => {
              console.error(err);
            }}
          />
          <Item>
            <Input
              style={{ width: '300px' }}
              placeholder="自行輸入卡號 Enter確認"
              name="cardNumber"
              value={cardNumber}
              onChange={(value) => {
                setCardNumber(value);
              }}
              onPressEnter={() => {
                try {
                  const foundData = cardArr.find(
                    (element) => element.cardNumber === cardNumber
                  );
                  // console.log(foundData)
                  if (foundData === undefined) {
                    const regex = /^[\d|a-zA-Z]+$/;
                    if (regex.test(cardNumber)) {
                      Message.success('掃描成功');
                      setCardInformationDialog(true);
                      setScanCardDialog(false);
                    } else {
                      Message.error('掃描失敗，僅能數字和英文(請切換英文輸入)');
                      setScanCardDialog(true);
                    }
                  } else {
                    Message.error('已有此卡號，請換另一張卡片');
                  }
                } catch (error) {
                  console.log('Error', error);
                }
              }}
            />
          </Item>

          <img
            className={styles.cardImage}
            src="/ezcon/img/Rfid.svg"
            alt="cardImg"
            type="cover"
            width={400}
            height={300}
          />

          <h1>請掃描卡片或自行輸入卡號...</h1>
        </Form>
      </Dialog>
      <Dialog
        hasMask
        className={styles.cardInformationDialog}
        visible={cardInformationDialog}
        onOk={() => {
          funCreateCard({
            cardNumber,
            cardStatus,
            cardNumbering,
          })
            .then((res) => {
              console.log('==cardNumber create success:', res);
              Message.success('新增成功');
              setCardNumber('');
              setCardNumbering('');
              setCardInformationDialog(false);
              serverCardDataUpdate();
            })
            .catch((error) => {
              console.log('==cardNumber create fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setCardNumber('');
          setCardNumbering('');
          setCardInformationDialog(false);
        }}
        onClose={() => {
          setCardNumber('');
          setCardNumbering('');
          setCardInformationDialog(false);
        }}
      >
        <h2>新增訪客卡</h2>
        <Form.Item label="卡號">{cardNumber}</Form.Item>
        <Form.Item label="卡片狀態">{cardStatus}</Form.Item>
        <Form.Item label="卡片編號(自行命名)">
          <Input
            name="cardNumbering"
            placeholder="請輸入卡片編號"
            onChange={(value) => {
              setCardNumbering(value);
            }}
          />
        </Form.Item>
      </Dialog>

      <Dialog
        hasMask
        className={styles.cardInformationDialog}
        visible={editCardInformationDialog}
        onOk={() => {
          const item = cardArr[editCardIndex];
          item.cardNumber = cardNumber;
          item.cardStatus = cardStatus;
          item.cardNumbering = cardNumbering;

          // 20220316 增加卡片遺失時顯示當下遺失時間
          if (cardStatus === '已遺失') item.allowTime = new Date().getTime();
          // 20220317 卡片遺失時紀錄管理者姓名
          item.householdNumber = name;

          funUpdateCard(item._id, item)
            .then((res) => {
              console.log('==cardNumber update success:', res);
              Message.success('更新成功');
              serverCardDataUpdate();
              setCardNumber('');
              setCardNumbering('');
              setEditCardInformationDialog(false);
            })
            .catch((error) => {
              console.log('==cardNumber update fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setCardNumber('');
          setCardNumbering('');
          setEditCardInformationDialog(false);
        }}
        onClose={() => {
          setCardNumber('');
          setCardNumbering('');
          setEditCardInformationDialog(false);
        }}
      >
        <h2>編輯訪客卡</h2>
        <Form.Item label="卡號">
          <Input
            value={cardNumber}
            name="cardNumber"
            placeholder="請輸入卡號"
            onChange={(value) => {
              setCardNumber(value);
            }}
          />
        </Form.Item>
        <Form.Item label="卡片狀態">
          <RadioGroup
            value={cardStatus}
            onChange={(value) => {
              setCardStatus(value);
            }}
          >
            <Radio id="unUsed" value="未使用">
              未使用
            </Radio>
            <Radio id="used" value="使用中">
              使用中
            </Radio>
            <Radio id="lost" value="已遺失">
              已遺失
            </Radio>
          </RadioGroup>
        </Form.Item>
        <Form.Item label="卡片編號(自行命名)">
          <Input
            value={cardNumbering}
            name="cardNumbering"
            placeholder="請輸入卡片編號"
            onChange={(value) => {
              setCardNumbering(value);
            }}
          />
        </Form.Item>
      </Dialog>

      <Dialog
        hasMask
        className={styles.cardInformationDialog}
        visible={cardInformationDialog}
        onOk={() => {
          funCreateCard({
            cardNumber,
            cardStatus,
            cardNumbering,
          })
            .then((res) => {
              console.log('==cardNumber create success:', res);
              Message.success('新增成功');
              setCardNumber('');
              setCardNumbering('');
              setCardInformationDialog(false);
              serverCardDataUpdate();
            })
            .catch((error) => {
              console.log('==cardNumber create fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setCardNumber('');
          setCardNumbering('');
          setCardInformationDialog(false);
        }}
        onClose={() => {
          setCardNumber('');
          setCardNumbering('');
          setCardInformationDialog(false);
        }}
      >
        <h2>新增訪客卡</h2>
        <Form.Item label="卡號">{cardNumber}</Form.Item>
        <Form.Item label="卡片狀態">{cardStatus}</Form.Item>
        <Form.Item label="卡片編號(自行命名)">
          <Input
            name="cardNumbering"
            placeholder="請輸入卡片編號"
            onChange={(value) => {
              setCardNumbering(value);
            }}
          />
        </Form.Item>
      </Dialog>

      <Dialog
        hasMask
        className={styles.cardInformationDialog}
        visible={addTimeDialog}
        onOk={() => {
          const item = {
            ...cardArr[editCardIndex],
            allowTime:
              new Date().getTime() +
              count * 1000 * 60 * 60 +
              minute * 1000 * 60,
          };
          console.log(item);

          funUpdateCardTime(item._id, item)
            .then((res) => {
              console.log('==cardNumber update success:', res);
              Message.success('更新成功');
              setCount(0);
              setMinute(0);

              serverCardDataUpdate();

              setAddTimeDialog(false);
            })
            .catch((error) => {
              console.log('==cardNumber update fail:', error);
              Message.error(`${error}`);
            });
          // 20220315 增加卡片加時成功推播
          axios('/ezcon/api/emitMsgQuery', {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: {
              service: 'message',
              event: 'msg',
              title: '訪客卡片加時成功',
              content: `住戶:${item.householdNumber},卡號:${
                item.cardNumber
              }加時至:${new Date(item.allowTime).toLocaleString()}成功`,
              type: 'success',
              class: 'visitorAppointmentRegistration',
              duration: 8000,
              redirect: '/ezpro/visitor/visitorAppointmentFrontDesk',
              query: {
                householdNumbers: {
                  $in: [item.householdNumber],
                },
                firebaseClass: '訪客管理',
              },
            },
          })
            .then((res) => {
              console.log('==send message Success:', res);
              // Message.success('已傳送推播給住戶');
            })
            .catch((error) => {
              console.error('==send message fail:', error);
            });
        }}
        onCancel={() => {
          setCount(0);
          setMinute(0);
          setAddTimeDialog(false);
        }}
        onClose={() => {
          setCount(0);
          setMinute(0);
          setAddTimeDialog(false);
        }}
      >
        <h2>新增訪客卡時效</h2>
        <Form.Item label="請輸入欲加時間">
          <div className={styles.time}>
            <NumberPicker
              min={0}
              value={count}
              onChange={(value) => {
                if (value) {
                  setCount(value);
                } else {
                  setCount(0);
                }
              }}
            />
            <p>小時</p>
            <TimePicker
              placeholder="請選擇時間"
              format="mm"
              value={minute}
              onChange={(value) => {
                if (value) {
                  setMinute(moment(value).format('mm'));
                }
              }}
            />
            <p>分鐘</p>
          </div>
        </Form.Item>
      </Dialog>
      {/* 20220317 調整表格顯示欄位 */}
      <Table dataSource={cardArr}>
        <Table.Column title="卡號" dataIndex="cardNumber" width={200} />
        <Table.Column
          title="卡片編號(自行命名)"
          dataIndex="cardNumbering"
          width={150}
        />
        <Table.Column
          title="戶號/姓名"
          dataIndex="householdNumber"
          width={100}
        />
        <Table.Column title="狀態" dataIndex="cardStatus" width={100} />
        <Table.Column
          title="卡片時效"
          width={200}
          cell={(_value, _index, record) => {
            return (
              <>
                {/* 20220316 增加卡片遺失時顯示當下遺失時間 */}
                {record.cardStatus === '已遺失' && (
                  <>
                    {moment(record.allowTime).format('YYYY-MM-DD HH:mm:ss')}{' '}
                    遺失
                  </>
                )}
                {record.cardStatus !== '已遺失' &&
                  Object.prototype.hasOwnProperty.call(record, 'allowTime') && (
                    <>
                      {moment(record.allowTime).format('YYYY-MM-DD HH:mm:ss')}
                      {moment() > record.allowTime && '(已過期)'}
                    </>
                  )}
              </>
            );
          }}
        />
        <Table.Column
          title="操作"
          width={300}
          lock="right"
          cell={(_value, index, record) => {
            return (
              <div className={styles.btn}>
                <Button
                  type="secondary"
                  disabled={record.cardStatus === '已遺失'}
                  onClick={() => {
                    setAddTimeDialog(true);
                    setEditCardIndex(index);
                  }}
                >
                  加時效
                </Button>

                <Button
                  type="normal"
                  onClick={() => {
                    setCardNumber(cardArr[index].cardNumber);
                    setCardNumbering(cardArr[index].cardNumbering);
                    setCardStatus(cardArr[index].cardStatus);
                    setEditCardIndex(index);
                    setEditCardInformationDialog(true);
                  }}
                >
                  編輯
                </Button>

                <Button
                  type="primary"
                  warning
                  onClick={() => {
                    funRemoveCard(cardArr[index]._id)
                      .then((res) => {
                        console.log('==cardNumber delete success:', res);
                        Message.success('刪除成功');
                        serverCardDataUpdate();
                      })
                      .catch((error) => {
                        console.log('==cardNumber delete fail:', error);
                        Message.error(`${error}`);
                      });
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }}
        />
      </Table>
    </>
  );
};

export default CardManagementList;
